import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  registerables as registerablesJS,
} from 'chart.js';
import { Color, ChartDataSet } from '../../types/app/chart.types';
import { Chart } from 'react-chartjs-2';
import moment from 'moment';
import { convertMsToTimeFormat } from '../../utils/core/functions/convertDateTime';
import ResizableBox from '../../components/app/ResizableBox/ResizableBox';
import { GRAY } from '../../utils/core/functions/colors.function';
import { ThemeType } from '../../hooks/useLocalTheme';

ChartJS.register(...registerablesJS);
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
);

interface Props {
  chartData: ChartDataSet[];
  labels: string[];
  displayLegend?: boolean;
  chartHeight?: string;
  chartWidth?: string;
  chartTitle?: string;
  localTheme?: ThemeType;
}

export function ChartsContainerCycleTime({
  chartData,
  labels,
  displayLegend = true,
  chartHeight,
  chartWidth,
  chartTitle,
  localTheme,
}: Props) {
  const preparedData = {
    labels,
    datasets: chartData.map((dataset: ChartDataSet) => {
      return {
        type: dataset.chartType as any,
        label: dataset.label,
        backgroundColor: dataset.colors.map(
          (color: Color) => 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')',
        ),
        borderColor: dataset.style.borderColor,
        borderWidth: dataset.style.borderWidth,
        fill: dataset.style.fill,
        data: dataset.y.map((item: any) => item),
      };
    }),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
      },
      y: {
        type: 'linear',
        position: 'left',
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
        ticks: {
          min: 0,
          max: moment('1970-02-01 23:59:59').valueOf(),
          stepSize: 1000,
          callback: (value: any) => {
            if (value > 86399000) {
              let time = moment(value);
              return time.add(-1, 'hour').add(-1, 'day').format(`D[${'d'}] HH:mm:ss`);
            } else {
              let time = moment(value);
              return time.add(-1, 'hour').format('HH:mm:ss');
            }
          },
        },
      },
    },
    plugins: {
      legend: {
        display: displayLegend,
      },
      title: {
        display: true,
        text: chartTitle ? chartTitle : '',
      },
      tooltip: {
        callbacks: {
          label: function (ms: any) {
            let tmpLabel = convertMsToTimeFormat(ms.raw);
            return tmpLabel;
          },
        },
      },
    },
  };

  const [widthNum, setWidthNum] = useState<number>(0);
  useEffect(() => {
    setWidthNum(preparedData.labels.length * 25);
  }, [preparedData]);
  return (
    <>
      {widthNum && (
        <div style={{ position: 'relative', width: '85vw', overflow: 'auto' }}>
          <div
            style={{
              height: 'auto',
              minWidth: '85vw',
              width: widthNum + 'px',
            }}
          >
            <ResizableBox
              height={400}
              width={
                visualViewport && visualViewport.width > widthNum ? visualViewport.width : widthNum
              }
            >
              <Chart type="bar" data={preparedData} options={options} />
            </ResizableBox>
          </div>
        </div>
      )}
    </>
  );
}
